import { navigate, routes } from "../lib/urls";

const onOpenUser = (userId: string) =>
  navigate(routes.modal.member, { id: userId });
const onOpenGroup = (groupId: string) =>
  navigate(routes.modal.group, { id: groupId });
const onOpenServiceAccount = (serviceAccountId: string) =>
  navigate(routes.modal.serviceAccount, { id: serviceAccountId });

export function usePrincipalModals() {
  return { onOpenUser, onOpenGroup, onOpenServiceAccount };
}
